import useStore from '../store';

/**
 * The user the data layer should scope by — either the Cognito userId
 * (when signed in) or the persistent anonymous UUID (offline-first first run).
 *
 * Returns `{ userId: null, isLoading: true }` only while auth is still resolving.
 */
export function useActiveUser() {
  const user = useStore((s) => s.user);
  const anonUserId = useStore((s) => s.anonUserId);
  const isLoading = useStore((s) => s.authLoading);

  if (isLoading) {
    return { userId: null, isAnonymous: false, isAuthed: false, isLoading: true };
  }
  const cognitoId = user?.userId || user?.username || null;
  if (cognitoId) {
    return { userId: cognitoId, isAnonymous: false, isAuthed: true, isLoading: false };
  }
  if (anonUserId) {
    return { userId: anonUserId, isAnonymous: true, isAuthed: false, isLoading: false };
  }
  return { userId: null, isAnonymous: false, isAuthed: false, isLoading: false };
}
